export default __webpack_public_path__ + "static/media/n.b88d6c52.png";